import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.8977 10.5227L12.3977 15.0227C12.1918 15.2287 11.8657 15.2418 11.6448 15.0615L11.6023 15.0227L7.10229 10.5227L7.89771 9.72729L12 13.8296L16.1023 9.72729L16.8977 10.5227Z",
		fill: "currentColor"
	})
});
export default SvgChevronDown2;
